import EmailConversation from "./EmailConversation";
import EmailItem from "./EmailItem";
import DraftEmailContent from "/lib/html5-software-library/src/ranj/eng/content/DraftEmailContent";
import EmailDraftItem from "./EmailDraftItem";
import EmailBoxType from "./EmailBoxType";
import EmailAddedEvent from "./EmailAddedEvent";
import EmailConversationStatusChangedEvent from "./EmailConversationStatusChangedEvent";

export default class EmailModel {
    constructor(dispatcher, languagePack, keyDecisionsConfig, variableManager) {
        this._dispatcher = dispatcher;
        this._languagePack = languagePack;
        this._keyDecisionsConfig = keyDecisionsConfig;
        this._variableManager = variableManager;
        
        this._conversationsChronologically = [];
        this._conversationsById = {};
    }

    addEmail(content) {
        const conversationId = content.getSubject();
        let emailItem;
        if (content instanceof DraftEmailContent) {
            emailItem = new EmailDraftItem(content);
        } else {
            emailItem = new EmailItem(content);
        }

        const isKeyDecision = this._keyDecisionsConfig.contentIsKeyDecision(content);
        const isUnlockingKeyDecision = this._keyDecisionsConfig.contentUnlocksKeyDecision(content);

        let conversation = this.getConversationById(conversationId);
        if (conversation == null) {
            conversation = new EmailConversation(conversationId, emailItem, isKeyDecision, isUnlockingKeyDecision);
            this.addConversation(conversation);
        } else {
            conversation.addItem(emailItem, isKeyDecision, isUnlockingKeyDecision);
        }

        this._dispatcher.dispatch(EmailAddedEvent.EMAIL_ADDED_TO_CONVERSATION, conversation, emailItem);
    }

    addConversation(conversation) {
        this._conversationsById[conversation.id] = conversation;
        this._conversationsChronologically.add(conversation);
    }

    getConversations() {
        return this._conversationsChronologically;
    }

    getConversationById(id) {
        return this._conversationsById[id];
    }
    
    getConversationForEmailItem(emailItem) {
        const conversationId = emailItem.content.getSubject();
        const conversation = getConversationById(conversationId);

        return conversation;
    }

    markRead(conversation, value = true) {
        conversation.markRead(value);

        const items = conversation.getItems();
        for (let i = 0; i < items.length; i++) {
            const emailItem = items[i];
            const contentId = emailItem.content.getContentID();
            this._variableManager.setVariable(`email_${contentId}_viewed`, true);
        }

        this._dispatcher.dispatch(EmailConversationStatusChangedEvent.STATUS_CHANGED, conversation);
    }

    getUnreadCount() {
        const unreadConversations = this._conversationsChronologically.filter(c => c.hasUnreadItems() === true && !c.isKeyDecision);
        return unreadConversations.length;
    }

    getConversationsForBoxType(emailBoxType) {
        switch (emailBoxType) {
            case EmailBoxType.INBOX:
                return this._conversationsChronologically.filter(c => c.isInbox());
            case EmailBoxType.DRAFTS:
                return this._conversationsChronologically.filter(c => c.requiresReply() && !c.isKeyDecision);
            case EmailBoxType.OUTBOX:
                return this._conversationsChronologically.filter(c => c.isOutbox());
        }
    }

    getUnreadCountForBoxType(emailBoxType) {
        switch (emailBoxType) {
            case EmailBoxType.INBOX:
                return this._conversationsChronologically.filter(c => c.isInbox() && c.hasUnreadItems()).length;
            case EmailBoxType.DRAFTS:
                return this._conversationsChronologically.filter(c => c.requiresReply() && !c.isKeyDecision).length;
            case EmailBoxType.OUTBOX:
                return 0;
        }
    }
    
    toObject() {
        let serializableConversationsById = {};
        for (const id in this._conversationsById) {
            const conversation = this._conversationsById[id];
            serializableConversationsById[id] = conversation.toObject();
        }

        return {
            conversationsChronologically: this._conversationsChronologically.map(c => c.toObject()),
            conversationsById: serializableConversationsById,
        };
    }

    fromObject(obj, languagePack) {
        this._conversationsChronologically = obj.conversationsChronologically.map(c => new EmailConversation().fromObject(c, languagePack));
        
        Object.keys(obj.conversationsById).map(k => {
            this._conversationsById[k] = new EmailConversation().fromObject(obj.conversationsById[k], languagePack)
        });
    }
}